module.exports = __webpack_public_path__ + "static/media/icon_great_than.52d85ca6.svg";